<div class="modal-column" *ngIf="!loading">
  <div class="log-in-form-block">
    <h5>Withdrawal confirmation</h5>
    <p class="subtext">Please check if withdrawal request is correct and confirm or cancel it:</p>
    <div class="spacer-10"></div>
    <p class="overflow">Withdrawal amount <strong>{{ data.amount }}</strong> {{ data.currency.toUpperCase() }}</p>
    <p class="overflow">Receiver wallet <strong>{{ data.receiver }}</strong></p>
    <p class="overflow">Request date <strong>{{ data.createdAt | date: 'short' }}</strong></p>
    <app-form-button class="primary" (click)="submit('confirm')" data-id="modalWithdrawConfirm-ok-button">
      Confirm withdrawal
    </app-form-button>
    <app-form-button (click)="submit('cancel')" data-id="modalWithdrawConfirm-cancel-button">
      Cancel withdrawal
    </app-form-button>
  </div>
  <a [routerLink]="['/', {outlets: { modal: null } } ]" class="icon close-popup"
     data-id="modalWithdrawConfirm-closer-href">
    <i class="fal fa-times"></i>
  </a>
</div>
<div class="modal-column" *ngIf="loading">
  <div class="log-in-form-block">
    <app-loader [isLoading]="true" message="Please wait..."></app-loader>
  </div>
  <a [routerLink]="['/', {outlets: { modal: null } } ]" class="icon close-popup"
     data-id="modalWithdrawConfirm-closer-href">
    <i class="fal fa-times"></i>
  </a>
</div>



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/template/modals/confirm-withdrawal/confirm-withdrawal-modal.template.html